<script>
  import { _ } from 'svelte-i18n'
  import { modals, storefront_url_to_open } from '../../stores';
  import Modal from '../../elements/Modal.svelte'
  import Button from '../../elements/Button.svelte'

  let modal_id = 'storefront_watermark_info'

  const handleOpenStorefront = () => {
    window.open($storefront_url_to_open, '_blank');
    closeModal();
  }

  const closeModal = () => {
    $storefront_url_to_open = '';
    modals.close();
  }

</script> 

<Modal id={modal_id}>
  <span class="header" slot="header">Quick note</span>
  <span class="content" slot="content">
    {#if $storefront_url_to_open}
      <p class="accent"><b>The storefront page you're about to view includes a watermark overlay.</b></p>
      <p>You can remove it by upgrading to the Business Plan before sharing with your customers.</p>
    {:else}
      <p><b>The page you just copied the address for includes a watermark overlay.</b></p>
      <p>You can remove it by upgrading to the Business Plan before sharing it with your customers.</p>
    {/if}
  </span>
  <span class="footer" slot="footer">
    {#if $storefront_url_to_open}
      <Button kind="accent" on:click={handleOpenStorefront}>{$_('buttons.openStorefront')}</Button>
    {:else}
      <Button kind="accent" on:click={closeModal}>{$_('buttons.ok')}</Button>
    {/if}
  </span>
</Modal>

<style>
  .header,
  .footer,
  .content {
    text-align: left;
  }
  .content {
    display: block;
    margin-bottom: 3rem;
  }
  .content p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
  }
  .accent {
    color: var(--c-accent);
  }
</style>